<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal
      ref="modal"
      :title="$t('reviews.review_reply')"
      size="md"
      centered
      no-close-on-backdrop
    >
      <form ref="form" @submit="submit">
        <h6>{{ $t('reviews.review_text') }}</h6>
        <p>{{ review.text }}</p>

        <b-form-group :label="$t('reviews.your_reply')">
          <b-form-textarea
            id="textarea"
            v-model="replyText"
            :value="review.company_reply"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import ReviewApi from './Api'

export default {
  name: 'ReplyModal',

  mixins: [FormMixin],

  props: {
    // eslint-disable-next-line vue/require-default-prop
    review: Object,
  },

  data() {
    return {
      replyText: '',
    }
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('close', () => {
      this.$emit('close')
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.submit()
    })

    modal.$on('cancel', () => {
      this.$emit('close')
    })
  },

  methods: {
    submit() {
      return this.$uiBlocker(
        new ReviewApi()
          .reply(this.review, this.replyText)
          .then(result => {
            this.$refs.modal.hide()
            this.$toast.success(result.message)
          })
          .catch(error => {
            if (error.status === 422) {
              this.setValidationErrors(error.data.errors)
            }
            return Promise.reject(error)
          }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
